import { initializeApp } from 'firebase/app'
import { getPerformance } from 'firebase/performance'
import type { FirebaseApp } from 'firebase/app'
import type { FirebasePerformance } from 'firebase/performance'
import type { Firestore } from 'firebase/firestore/lite'

interface FirebaseConfig {
  apiKey?: string
  authDomain?: string
  projectId?: string
  storageBucket?: string
  messagingSenderId?: string
  appId?: string
  measurementId?: string
}

// eslint-disable-next-line no-undef
const isDevEnv = process.env.NODE_ENV === 'development'

let firebaseApp: FirebaseApp | null = null
let perf: FirebasePerformance | null = null
let store: Firestore | null = null

/**
 * Get Firebase app singleton instance
 * @returns firebaseApp
 */
export function getApp({
  apiKey = 'AIzaSyCU6vM6fJjLKrTUkJuWSiNY786TEraAn9k',
  authDomain = 'onx-fish-web.firebaseapp.com',
  projectId = 'onx-fish-web',
  storageBucket = 'onx-fish-web.firebasestorage.app',
  messagingSenderId = '610859952124',
  appId = '1:610859952124:web:06298d54efc6a77ab9f479',
  measurementId = 'G-L5KEQBE4ZW',
}: FirebaseConfig = {}): FirebaseApp {
  if (firebaseApp) {
    return firebaseApp
  }
  const config = {
    apiKey,
    authDomain,
    projectId,
    storageBucket,
    messagingSenderId,
    appId,
    measurementId,
  }
  // non-secret config
  firebaseApp = initializeApp(config)
  return firebaseApp
}

/**
 * Get Firebase performance singleton instance
 * @returns performance
 */
export function initPerf(
  config: FirebaseConfig = {}
): FirebasePerformance | null {
  if (perf) {
    return perf
  }
  if (!isDevEnv) {
    perf = getPerformance(getApp(config))
  }
  return perf
}

/**
 * Get Firestore singleton instance
 * @returns Promise<firestore>
 */
export async function getStore(
  config: FirebaseConfig = {}
): Promise<Firestore> {
  if (store) {
    return store
  }
  const { getFirestore } = await import('firebase/firestore/lite')
  store = getFirestore(getApp(config))
  return store
}
